// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}
ion-item ion-toggle {
  height: 24px;
  width: 42px;
  margin-right: 16px;
  --handle-width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/customers/modals/create-contact/create-contact.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;AACI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AACR","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n\n    ion-toggle {\n        height: 24px;\n        width: 42px;\n        margin-right: 16px;\n        --handle-width: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
